import React from 'react';

import InsuranceShield from 'assets/icons/InsuranceShield';
import { BRAND_COLORS } from 'brand-guidelines/colors';

import { Text, Wrapper } from './styled-components';

const getBadgeOptions = (inNetwork: boolean) => {
  if (inNetwork) {
    return {
      label: 'In-Network',
      color: BRAND_COLORS.lightGreen,
      icon: <InsuranceShield inNetwork size={14} />,
    };
  }

  return {
    label: 'Out-of-Network',
    color: BRAND_COLORS.red,
    icon: <InsuranceShield inNetwork={false} size={14} />,
  };
};

interface InsuranceStatusBadgeProps {
  inNetwork: boolean;
  applyMargin?: boolean;
}

export const InsuranceStatusBadge = ({ inNetwork, applyMargin }: InsuranceStatusBadgeProps) => {
  if (typeof inNetwork !== 'boolean') {
    return null;
  }

  const { color, icon, label } = getBadgeOptions(inNetwork);

  return (
    <Wrapper $color={color} $applyMargin={applyMargin}>
      {icon}
      <Text color={color}>{label}</Text>
    </Wrapper>
  );
};
